import { type SizeValue, isSizePreset, sizeToCss } from "@frontend/styles";
import { SIZES } from "@frontend/styles/constants";

import type { KnobSize } from "./Knob.types";

export const KNOB_TAG_NAME = "knob" as const;

type KnobSizeDimensions = {
  diameter: number;
  strokeWidth: number;
  thumbSize: number;
  boxSize: string;
};

type KnobGeometry = Omit<KnobSizeDimensions, "boxSize">;

export const KNOB_SIZES: Record<KnobSize, KnobGeometry> = {
  sm: { diameter: 72, strokeWidth: 6, thumbSize: 12 },
  md: { diameter: 96, strokeWidth: 8, thumbSize: 14 },
  lg: { diameter: 128, strokeWidth: 10, thumbSize: 16 },
};

const STROKE_WIDTH_RATIO = KNOB_SIZES.md.strokeWidth / KNOB_SIZES.md.diameter;
const THUMB_SIZE_RATIO = KNOB_SIZES.md.thumbSize / KNOB_SIZES.md.diameter;

export function getKnobSizeDimensions(
  size: SizeValue<KnobSize>,
): KnobSizeDimensions {
  if (isSizePreset(size, SIZES)) {
    const geometry = KNOB_SIZES[size];

    return { ...geometry, boxSize: `${geometry.diameter}px` };
  }

  if (typeof size === "string") {
    return { ...KNOB_SIZES.md, boxSize: size };
  }

  return {
    diameter: size,
    strokeWidth: size * STROKE_WIDTH_RATIO,
    thumbSize: size * THUMB_SIZE_RATIO,
    boxSize: sizeToCss(size),
  };
}
